/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_4Inputs */

const es_chat_suggestions_welcome_4 = /** @type {(inputs: Chat_Suggestions_Welcome_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola ${i?.name}. Podés comenzar con cualquier pregunta o tarea.`)
};

const en_chat_suggestions_welcome_4 = /** @type {(inputs: Chat_Suggestions_Welcome_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello ${i?.name}. Feel free to start with any question or task.`)
};

/**
* | output |
* | --- |
* | "Hello {name}. Feel free to start with any question or task." |
*
* @param {Chat_Suggestions_Welcome_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_4 = /** @type {((inputs: Chat_Suggestions_Welcome_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_4(inputs)
	return en_chat_suggestions_welcome_4(inputs)
});
export { chat_suggestions_welcome_4 as "chat.suggestions.welcome_4" }